<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 55 47"
  >
    <path
      stroke="#222"
      stroke-width="5"
      d="M.96 2.663H55M.96 23.105H55M.96 43.54H55"
    />
  </svg>
</template>
